import { openModal } from 'features/modal/modalSlice';
import { kickUsersRequested } from 'features/users/actions';
import { put, select } from 'redux-saga/effects';
import { RoleEntries } from 'features/permissions/types';
import { selectRoleEntries } from 'features/permissions/permissionsSlice';

export function* onKickUsersRequestedSaga(action: ReturnType<typeof kickUsersRequested>) {
  const role = action.payload;

  const roles: RoleEntries = yield select(selectRoleEntries);

  yield put(
    openModal('kickUsersConfirmation', {
      role,
      displayRoleName: roles[role].displayName,
    })
  );
}
